import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/shared/services/user.service';
declare var $:any
@Component({
  selector: 'app-kra-incentive-list-add',
  templateUrl: './kra-incentive-list-add.component.html',
  styleUrls: ['./kra-incentive-list-add.component.css']
})
export class KraIncentiveListAddComponent implements OnInit {
  max_date = new Date();
  d2Day: Date
  EnableHumanMMU: boolean = false;
  is1962LiveStock: boolean = false;
  mvuLst: any = [];
  MVU: any = '';
  user_type_id: any = '';
  dtRender: boolean = true;
  dtOptions: any = {};
  lstGrid: any = [];
  start_date: any = new Date()
  doctorList: any = [];
  nurseList: any = [];
  showDetails:boolean = false;
  summaryList: any[] = [];
summaryTotals: any = {};

selectedUser: any = null;
filteredRoles: any[] = [];
userWiseView :boolean = false

 // Deduction Modal data
  deductionForm!: FormGroup;
  roleList: any[] = [];
  rolesData: any[] = [];
  modalTitle: any;
  kraList:  any[] = [];
  kpiList:  any[] = [];
  targetTypeList:  any[] = [];
  rulesData: any;
  deductionEmail:any = 'Yes'
  submitted : boolean = false;
  screennames: any;
  isEditDeduction: boolean= false;
  editData: any;
  selectedSlab: any;
  editIncentives: boolean = false;
  incentiveRolesData: any[]=[];
  finalRoles: any;
  selectedMMU: any;
  SelectedDate = new Date();
  dtRender1: boolean;
  descriptionList: any;
  get f() { return this.deductionForm.controls; }
  triggered_days:any;
  deduction_amount:any;

 // Incentives Modal data
  slabsList: any[] = [];
  incentiveForm!: FormGroup;
  get g() { return this.incentiveForm.controls; }

 

 

  constructor(
    private regService: RegistrationService
    , protected toastr: ToastrService
    , private modalService: NgbModal
    , public activeModal: NgbActiveModal
    , private formBuilder: FormBuilder
    , private datePipe: DatePipe
    , private route: ActivatedRoute
    , public changeDetection: ChangeDetectorRef
    , public router: Router
  ) {
    this.navigateSceen();
   }

  ngOnInit(): void {
    this.getFeaturePermission();
    this.sideMenupermission();
    this.getMvuList();
    // this.LoadData();
    this.onSubmit()
    this.deductionFormInIt();
    this.incentivesInitForm();
  }

  navigateSceen(){
     const nav = this.router.getCurrentNavigation();
    if(nav?.extras?.state){ 
  this.MVU = nav?.extras?.state?.['mvuId'] || '';
  this.selectedMMU = nav?.extras?.state?.['selectedMMU'];
  this.start_date = new Date(nav?.extras?.state?.['reportDate']);
  this.SelectedDate = new Date(nav?.extras?.state?.['selectedDate']);
    }
  
  }

    sideMenupermission() {
    this.screennames = JSON.parse(sessionStorage.getItem('menu'));

  }
  getFeaturePermission() {
    var featureList: any = JSON.parse(localStorage.getItem('featuresList')) || [];
    for (let i = 0; i < featureList.length; i++) {
      if (featureList[i].feature_id.feature_name == "EnableHumanMMU") {

        this.EnableHumanMMU = featureList[i].patient;
      }
      if (featureList[i].feature_id.feature_name == "1962LiveStock") {

        this.is1962LiveStock = featureList[i].patient;
      }
    }
  }
  calculateTotals() {
    this.rolesData.forEach((role:any) => {
      role.totalAmount = role.records.reduce((sum: number, item: any) => {
        return sum + (Number(item.deductionAmount) || 0);
      }, 0);
    });
  }
  getMvuList() {
    let payload =
    {
      "state_id": this.is1962LiveStock ? 121 : sessionStorage.stateId,
      "district_id": -1,
      "mandal_id": -1,
      "village_id": -1
    }
    this.regService.post(`mvu/mvuteam/getallmvusbylocation`, payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
             this.mvuLst = (res.data ?? []).sort((a: any, b: any) =>
          (a.mvu_name || '').localeCompare(b.mvu_name || '')
        );

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }

 onSubmit() {
  this.dtRender1 = false;

  if (!this.MVU) {
    this.toastr.info("Please Select MMU");
    return;
  }

  const payLoad = {
    mvu_id: [this.MVU],
    from_date: this.datePipe.transform(
      new Date(this.start_date.getFullYear(), this.start_date.getMonth(), 1),
      'yyyy-MM-dd'
    )
  };

  this.regService.post(`mvu/employee-penalty/getlist`, payLoad).subscribe({
    next: (res: any) => {

      if (res.status !== 'OK') {
        this.toastr.error(res.message);
        return;
      }

      const penalties = res?.data?.penalty || {};
      const incentives = res?.data?.incentive || {};

      const ignoreRoles = ['unknown', '', null, undefined];

      // =========================================
      // ✅ USER SUMMARY MAP
      // =========================================
      const userMap: any = {};

      // 🔴 PROCESS PENALTIES
      Object.keys(penalties)
        .filter(role => !ignoreRoles.includes(role?.toLowerCase?.().trim()))
        .forEach(role => {

          (penalties[role] || []).forEach((item: any) => {

            const userId = item.userId;

            if (!userMap[userId]) {
              userMap[userId] = {
                userId: userId,
                mvuName: item.mvuName,
                userName: (item.userName || '').toUpperCase().trim(),
                roleName: item.roleName || role,
                totalIncentive: 0,
                totalDeduction: 0,
                incentiveCount: 0,
                deductionCount: 0
              };
            }

           if (!item.isBlock) {   // ✅ ONLY UNBLOCKED

           userMap[userId].totalDeduction += Number(item.deductionAmount || 0);
           userMap[userId].deductionCount += 1;

}

          });

        });

      // 🟢 PROCESS INCENTIVES
      Object.keys(incentives)
        .filter(role => !ignoreRoles.includes(role?.toLowerCase?.().trim()))
        .forEach(role => {

          (incentives[role] || []).forEach((item: any) => {

            const userId = item.userId;

            if (!userMap[userId]) {
              userMap[userId] = {
                userId: userId,
                mvuName: item.mvuName,
                userName: (item.userName || '').toUpperCase().trim(),
                roleName: item.roleName || role,
                totalIncentive: 0,
                totalDeduction: 0,
                incentiveCount: 0,
                deductionCount: 0
              };
            }

            userMap[userId].totalIncentive += Number(item.incentiveAmount || 0);
            userMap[userId].incentiveCount += 1;

          });

        });

      // =========================================
      // ✅ SUMMARY LIST
      // =========================================
      this.summaryList = Object.values(userMap).map((user: any) => ({
        ...user,
        netAmount: user.totalIncentive - user.totalDeduction
      }));

      // =========================================
      // ✅ TOTALS
      // =========================================
      this.summaryTotals = {
        totalIncentive: this.summaryList.reduce((sum: number, x: any) => sum + x.totalIncentive, 0),
        totalDeduction: this.summaryList.reduce((sum: number, x: any) => sum + x.totalDeduction, 0),
        netAmount: this.summaryList.reduce((sum: number, x: any) => sum + x.netAmount, 0),
        incentiveCount: this.summaryList.reduce((sum: number, x: any) => sum + x.incentiveCount, 0),
        deductionCount: this.summaryList.reduce((sum: number, x: any) => sum + x.deductionCount, 0)
      };

      this.dtRender1 = true;
      // this.toastr.success(res.message);
    },

    error: (err: HttpErrorResponse) => {
      this.dtRender1 = true;
      this.toastr.error(err.message);
    }
  });
}

viewDetails(user: any) {
  this.LoadData();
  setTimeout(() => {
    if (!this.finalRoles || this.finalRoles.length === 0) {
    console.error('finalRoles is empty or not loaded');
    return;
  }

  console.log('Clicked user:', user);

  this.selectedUser = user;
  $('#userWiseView').modal('show')

  this.filteredRoles = this.finalRoles
    .map((role: any) => {

      const deductions = (role.deductions || [])
        .filter((d: any) => Number(d.userId) === Number(user.userId));

      const incentives = (role.incentives || [])
        .filter((i: any) => Number(i.userId) === Number(user.userId));

      return {
        roleName: role.roleName,
        deductions,
        incentives
      };

    })
    .filter((role: any) =>
      role.deductions.length > 0 || role.incentives.length > 0
    );

  console.log('Filtered Roles:', this.filteredRoles);
  }, 200);
  
}


  LoadData() {
  //  this.showDetails = true
    if (this.MVU == '' || this.MVU == undefined || this.MVU == null) {
      this.toastr.info("Please Select MMU");
      return;
    }
    this.lstGrid = [];
    this.dtRender = false;
    let payLoad = {
      "mvu_id": [this.MVU],
      "from_date": this.datePipe.transform(new Date(this.start_date.getFullYear(), this.start_date.getMonth(), 1), 'yyyy-MM-dd'),
    }
    this.regService.post(`mvu/employee-penalty/getlist`, payLoad).subscribe({
  next: res => {
    if (res.status == 'OK') {

      const data = res?.data.penalty || {};
      const data1 = res?.data.incentive || {};

      const ignoreRoles = ['unknown', null, '', undefined];

      // ✅ FILTERED penalty roles
      this.rolesData = Object.keys(data)
        .filter(role => !ignoreRoles.includes(role?.toLowerCase?.().trim()))
        .map(role => ({
          roleName: role,
          records: data[role]
        }));

      // ✅ FILTERED incentive roles
      this.incentiveRolesData = Object.keys(data1)
        .filter(role => !ignoreRoles.includes(role?.toLowerCase?.().trim()))
        .map(role => ({
          roleName: role,
          records: data1[role]
        }));

      this.finalRoles = [];

      // ✅ Merge penalty + incentives
      this.rolesData.forEach(role => {
        const inc = this.incentiveRolesData.find(i =>
          i.roleName?.toLowerCase().trim() === role.roleName?.toLowerCase().trim()
        );

        this.finalRoles.push({
          roleName: role.roleName,
          deductions: role.records || [],
          incentives: inc?.records || []
        });
      });

      // ✅ Add ONLY incentive roles (no duplicates)
      this.incentiveRolesData.forEach(inc => {
        const exists = this.finalRoles.find((r: any) =>
          r.roleName?.toLowerCase().trim() === inc.roleName?.toLowerCase().trim()
        );

        if (!exists) {
          this.finalRoles.push({
            roleName: inc.roleName,
            deductions: [],
            incentives: inc.records || []
          });
        }
      });

      // ✅ Set original values ONCE after finalRoles is fully built
      this.finalRoles.forEach((role: any) => {

        // 🔴 DEDUCTIONS
        (role.deductions || []).forEach((item: any) => {
          item.isSelected = false;
          item.originalDeductionAmount = item.deductionAmount;
          item.originalIsBlock = item.isBlock;
          item.remarks = item.remarks || '';
        });

        // 🟢 INCENTIVES
        (role.incentives || []).forEach((item: any) => {
          item.isSelected = false;
          item.originalIncentiveAmount = item.incentiveAmount;
          item.originalIsActive = item.isActive;
        });

      });

      

      // this.toastr.success(res.message);

    } else {
      this.dtRender = true;
      this.toastr.error(res.message);
    }
  },
  error: (err: HttpErrorResponse) => {
    this.dtRender = true;
    this.toastr.error(err.message);
  }
});

  }



  goBackToSummary() {
  this.showDetails = false;
  this.selectedUser = null;
  this.filteredRoles = [];
  if(this.showDetails){
    this.LoadData();
  }else{
  this.onSubmit();
  }
  
}

goBackCheck(){
  if(!this.showDetails){
    this.goBack()
  }else{
   this.goBackToSummary(); 
  }
}


  goBack(): void {
    this.router.navigate(['home/kra/kralist'], {
    state: { mvuId: this.MVU ,selectedMMU : this.selectedMMU,selectedDate : this.SelectedDate }
  });
  }

    getUserRole() {
    
    this.regService.get(`mvu/employee-penalty/getmappedusers/${this.MVU}`).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.roleList = res.data ?? []
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
    getKRA(value:any) {
       const selected = this.roleList.find(r =>  r.role_id == value);

  if (selected) {
    this.deductionForm.patchValue({
      userId: selected.user_id,
      userName: selected.user_name,
      roleName : selected.role_name,
      kraId : '',
      kpiId:'',
      targetTypeId:'',
       deductionAmount:''

    });
  }
  this.kraList = []
    this.regService.get(`mvu/employee-penalty/getmasterkras/${value}`).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.kraList = res.data ?? []
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
    getKPI(value:any) {
       const selected = this.kraList.find(k => k.id == value);

  if (selected) {
    this.deductionForm.patchValue({
      kraName: selected.kra_type,
      kpiId:'',
      targetTypeId:'',
       deductionAmount:''
    });
  }
  this.kpiList = []
    this.regService.get(`mvu/employee-penalty/getmasterkpis/${value}`).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.kpiList = res.data ?? []
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
    getTargetTypes(value:any) {
        const selected = this.kpiList.find(k => k.id == value);

  if (selected) {
    this.deductionForm.patchValue({
      kpiName: selected.kpi_type,
      targetTypeId:'',
      deductionAmount:''

    });
  }
  this.targetTypeList= []
    this.regService.get(`mvu/employee-penalty/getmastertargettypes/${value}`).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.targetTypeList = res.data ?? []
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
    getRules(value:any) {
        const selected = this.targetTypeList.find(t => t.id == value);

  if (selected) {
    this.deductionForm.patchValue({
      targetName: selected.target_type
    });
  }
  this.rulesData = {}
    this.regService.get(`mvu/employee-penalty/getmasterrules/${value}`).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.rulesData = res.data[0] ?? []
          this.deductionForm.patchValue({
            deductionAmount : this.rulesData?.deduction_amount
          })
          
          this.triggered_days = this.rulesData?.triggered_days

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }

  
  deductionFormInIt(){
this.deductionForm = this.formBuilder.group({
      id: [0],
      userId: [''],
      userName: [''],
      roleId: ['',Validators.required],
      roleName: [''],
      mvuId: [''],
      mvuName: [''],
      deductionAmount: ['',Validators.required],
      kraId: ['',Validators.required],
      kraName: [''],
      kpiId: ['',Validators.required],
      kpiName: [''],
      targetTypeId: ['',Validators.required],
      targetName: [''],
      isBlock: [false],
      createdOn: [new Date()],
      remarks:['']

})
  }
openDeductionModal(item:any,isEdit:boolean){
  this.isEditDeduction = false
  this.submitted = false
  if(this.MVU === '' || this.MVU === null || this.MVU === undefined){
  this.toastr.info(`Please Select ${this.EnableHumanMMU?'MMU':'MVU'}`)
  return
  }
  this.deductionFormInIt();       // ✅ FIRST create form
  this.getUserRole();
  this.modalTitle = isEdit ? 'Edit Deduction' : 'Add Deduction';

  $('#deduction').modal('show');  // ✅ THEN open modal
  if(item && isEdit){
     setTimeout(() => {
    this.isEditDeduction = true
    this.patchDeductionValues(item)
    this.editData = item
  }, 100);
  }

}
toggleRow(item: any) {
  if (!item.isSelected) {
    // 🔁 Restore original values when UNCHECKED
    item.deductionAmount = item.originalDeductionAmount;
    item.isBlock         = item.originalIsBlock;
    item.remarks         = '';   // clear any typed remarks
  }
}

toggleIncentiveRow(item: any) {

  if (!item.isSelected) {

    // 🔁 restore original values
    item.incentiveAmount = item.originalIncentiveAmount;
    item.isActive = item.originalIsActive;

  }

}
getDeductionTotal(role: any): number {
  return (role.deductions || [])
    .filter((d: any) => !d.isBlock) // ✅ only unblocked
    .reduce((sum: number, d: any) => sum + (d.deductionAmount || 0), 0);
}

getIncentiveTotal(role: any): number {
  return (role.incentives || [])
    .reduce((sum: number, i: any) => sum + (i.incentiveAmount || 0), 0);
}

patchDeductionValues(item:any){
this.getKRA(item.roleId)
this.getKPI(item.kraId);
this.getTargetTypes(item.kpiId);
this.getRules(item.targetTypeId)
setTimeout(() => {
  this.deductionForm.patchValue(item)
  this.deductionForm.patchValue({
    createdOn : new Date(item.createdOn)
  })
}, 200);
}


 getFormValidationErrors() {
    Object.keys(this.deductionForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.deductionForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }
 getFormValidationErrors1() {
    Object.keys(this.incentiveForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.incentiveForm.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });
  }

  submitDeduction(){  // Save using POPUP
  
    // if(this.deduction_amount === null || this.deduction_amount === '' || this.deduction_amount === undefined){
    //   this.toastr.error("Please Enter Deduction Amount")
    //   return;
    // }
   if (this.deductionForm.value.isBlock) {
  this.deductionForm.get('remarks')?.setValidators([Validators.required]);
  this.deductionForm.get('remarks')?.updateValueAndValidity();
} else {
  this.deductionForm.get('remarks')?.clearValidators();
  this.deductionForm.get('remarks')?.updateValueAndValidity();
}


    event.preventDefault(), this.submitted = true, 
    this.getFormValidationErrors();
        if (this.deductionForm.invalid) {
          this.toastr.info('Enter all Mandatory Fields');
          return;
        }else{
           const selected = this.mvuLst.find((t:any) => t.mvu_id === Number(this.MVU));
          const payload = JSON.parse(JSON.stringify(this.deductionForm.getRawValue())); 
          payload.id = this.isEditDeduction ? this.editData.id : 0
          payload.mvuId = this.MVU
          payload.mvuName = selected.mvu_name
          payload.createdOn = this.datePipe.transform(new Date(this.deductionForm.value.createdOn),'yyyy-MM-ddTHH:mm:ss')
          // console.log('payload deduction',payload)
    this.regService.post(`mvu/employee-penalty/save`,payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
        this.toastr.success(res.message);
        $('#deduction').modal('hide'); 
        this.submitted = false
        this.deductionFormInIt();
        if(this.showDetails){
         this.LoadData();
        }else{
          this.onSubmit()
        }
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

        }    

  }

  submitDeduction2(item:any){ //Save without POPUP
      // ❌ Check if no changes
  if (
    item.deductionAmount === item.originalDeductionAmount &&
    item.isBlock === item.originalIsBlock
  ) {
    this.toastr.info('No changes to save');
    return;
  }

  // ❌ Validate amount
  if (item.deductionAmount === null || item.deductionAmount === '') {
    this.toastr.error('Amount is required');
    return;
  }

  // ❌ Validate remarks when blocked
  if (item.isBlock && (!item.remarks || item.remarks.trim() === '')) {
    this.toastr.error('Reason is mandatory when blocking a record');
    return;
  }

    let payload = {
     "id": item.id,
  "userId": item.userId,
  "userName": item.userName,
  "roleId": item.roleId,
  "roleName": item.roleName,
  "mvuId": item.mvuId,
  "mvuName": item.mvuName,
  "deductionAmount": item.deductionAmount,
  "kraId": item.kraId,
  "kraName": item.kraName,
  "kpiId": item.kpiId,
  "kpiName": item.kpiName,
  "targetTypeId": item.targetTypeId,
  "targetName": item.targetName,
  "isBlock": item.isBlock,
  "remarks": item.isBlock ? (item.remarks || '') : null,
  "createdOn": this.datePipe.transform(new Date(item.createdOn),'yyyy-MM-ddTHH:mm:ss')
    }
     this.regService.post(`mvu/employee-penalty/save`,payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
        this.toastr.success(res.message);
        $('#deduction').modal('hide'); 
        this.submitted = false
        this.deductionFormInIt();
         this.LoadData();
       
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

  }

  //  Incentives


incentivesInitForm() {
  this.incentiveForm = this.formBuilder.group({
    id: [0],
    userId: ['',Validators.required],
    userName: [''],
    mvuId: [''],
    slabId:['',Validators.required],
    mvuName: [''],
    description: [''],
    incentiveAmount: [{value: 'Nancy', disabled: true}, Validators.required],
    isActive: [true],
    modifiedBy: [''],
    totalAmount:[{ value: '', disabled: true }],
    roleId:[''],
    roleName:[''],
    slabDescriptionId:['',Validators.required],
    createdOn:[new Date()]
  });
}
  openIncentives(item:any,isEdit:boolean){
      if(this.MVU === '' || this.MVU === null || this.MVU === undefined){
  this.toastr.info(`Please Select ${this.EnableHumanMMU?'MMU':'MVU'}`)
  return
  }
    this.editData = null
    this.slabsList = []
    this.getSlabs();
    this.incentivesInitForm();
    this.getUserRole();
    this.modalTitle = isEdit ? 'Edit Incentives' : 'Add Incentives'
    $('#incentives').modal('show')
    if(isEdit && item){
      setTimeout(() => {
    this.editIncentives = true
     this.editData = item
      this.changeSlab(this.editData.slabId)
     this.incentiveForm.patchValue(this.editData)
     this.incentiveForm.patchValue({
      createdOn : new Date(this.editData.createdOn)
     })
     
      }, 300);
    
    }
  }

  getUserName(value:any){
    const selected = this.roleList.find(r =>  r.user_id == value);

  if (selected) {
    this.incentiveForm.patchValue({
      userName: selected.user_name,
      roleId : selected.role_id,
      roleName : selected.role_name
    });
  }
  const formValue = this.incentiveForm.getRawValue();

if (formValue.slabId && formValue.totalAmount) {
  this.amountCalculations();
}
  }

  changeSlab(value:any){
   this.selectedSlab = this.slabsList.find(t => t.id == value);

  if ( this.selectedSlab) {
    this.incentiveForm.patchValue({
      totalAmount: this.selectedSlab.slab_amount
    });
  }
  this.amountCalculations();
  this.getDescription(value)
 
  }
  getDescription(value:any){
    this.regService.get(`mvu/employee-incentives/getslabdescription/${value}`).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.descriptionList = res.data

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    }); 
  }

  selectDesc(value:any){
    let description = this.descriptionList.find((t:any) => t.id == value);
    this.incentiveForm.patchValue({
      description : description.description
    })

  }

 amountCalculations() {

  const formValue = this.incentiveForm.getRawValue(); // ✅ includes disabled

  let incentive = 0;

  if (formValue.roleId === 7) {
    // Doctor → 40%
    incentive = formValue.totalAmount * 0.40;
  } else {
    // Others → 20%
    incentive = formValue.totalAmount * 0.20;
  }

  this.incentiveForm.patchValue({
    incentiveAmount: incentive
  });
}
  

  getSlabs(){
    this.slabsList = []
 this.regService.get(`mvu/employee-incentives/getslabs`).subscribe({
      next: res => {
        if (res.status == 'OK') {
          this.slabsList = res.data

        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

  }

  incentivesSubmit(){  //With POPUP
    event.preventDefault(), this.submitted = true, 
    this.getFormValidationErrors1();
        if (this.incentiveForm.invalid) {
          this.toastr.info('Enter all Mandatory Fields');
          return;
        }else{
           const selected = this.mvuLst.find((t:any) => t.mvu_id === Number(this.MVU));
          const payload = JSON.parse(JSON.stringify(this.incentiveForm.getRawValue())); 
          payload.id = this.editIncentives ? this.editData.id : 0
          payload.mvuId = this.MVU
          payload.mvuName = selected.mvu_name
          payload.createdOn = this.datePipe.transform(new Date(this.incentiveForm.value.createdOn),'yyyy-MM-ddTHH:mm:ss')
          // console.log('payload deduction',payload)
         delete payload.totalAmount
    this.regService.post(`mvu/employee-incentives/save`,payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
        this.toastr.success(res.message);
        $('#incentives').modal('hide'); 
        this.submitted = false
        this.editIncentives = false
        this.incentivesInitForm();
        if(this.showDetails){
         this.LoadData();
        }else{
          this.onSubmit()
        }
        
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });

        }    
  }

  incentivesSubmit2(item:any){ // without POPUP
      // ❌ No changes
  if (
    item.incentiveAmount === item.originalIncentiveAmount &&
    item.isActive === item.originalIsActive
  ) {
    this.toastr.info('No changes to save');
    return;
  }

  // ❌ Validate
  if (item.incentiveAmount === null || item.incentiveAmount === '') {
    this.toastr.error('Amount is required');
    return;
  }
    //  if(!item.incentiveAmount){
    //   this.toastr.warning('Incentive amount can not be empty')
    //   return
    // }
    let payload={
  "id": item.id,
  "userId": item.userId,
  "userName": item.userName,
  "mvuId": item.mvuId,
  "mvuName": item.mvuName,
  "description": item.description,
  "incentiveAmount": item.incentiveAmount,
  "isActive": true,
  "slabId":item.slabId,
  "roleId":item.roleId,
  "roleName":item.roleName,
  "modifiedBy": sessionStorage.getItem('loginId')
    }
    this.regService.post(`mvu/employee-incentives/save`,payload).subscribe({
      next: res => {
        if (res.status == 'OK') {
        this.toastr.success(res.message);
        $('#incentives').modal('hide'); 
        this.submitted = false
        this.editIncentives = false
        this.incentivesInitForm();
         this.LoadData();
        
        
        } else {
          let errMsg: string = res.message;
          this.toastr.error(errMsg);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message);

      },
      complete: () => {
        // Any additional logic after patching values
      },
    });
  }
}
